import { render, staticRenderFns } from "./unicomJz.vue?vue&type=template&id=08f7a76e&scoped=true"
import script from "./unicomJz.vue?vue&type=script&lang=js"
export * from "./unicomJz.vue?vue&type=script&lang=js"
import style0 from "./unicomJz.vue?vue&type=style&index=0&id=08f7a76e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08f7a76e",
  null
  
)

export default component.exports